import React from "react";
import { useTranslation } from "react-i18next";
// import { useConcerts } from "../../hooks/useConcert";
import livesData from "../../data/lives.json";

type NavigationLinksProps = {
  onClick?: () => void;
  showLive?: boolean;
  variant?: "header" | "footer";
};

export const NavigationLinks: React.FC<NavigationLinksProps> = ({
  onClick,
  showLive = true,
  variant = "header",
}) => {
  // const concerts = useConcerts();

  const concerts = livesData.filter((concert) => {
    // Convertir la date du concert en objet Date
    const [year, month, day] = concert.date.split("/").map(Number);
    const concertDate = new Date(year, month - 1, day);
    // Comparer avec la date actuelle
    return concertDate >= new Date();
  });

  const { t } = useTranslation();

  if (!concerts || concerts.length === 0) {
    showLive = false;
  }

  const linkClassName =
    variant === "header" ? "nav-link-header" : "nav-link-footer";

  return (
    <>
      {showLive && (
        <a href="#live" className={linkClassName} onClick={onClick}>
          {t("live")}
        </a>
      )}
      <a href="#video" className={linkClassName} onClick={onClick}>
        {t("video")}
      </a>
      <a href="#music" className={linkClassName} onClick={onClick}>
        {t("music")}
      </a>
      <a href="#bio" className={linkClassName} onClick={onClick}>
        {t("bio")}
      </a>
      <a href="#contact" className={linkClassName} onClick={onClick}>
        {t("contact")}
      </a>
    </>
  );
};
